import React from 'react';
import { DTOrderSearchView } from '../../DTOrderSearchView';
import { processRbiOrderRefundItems } from '../../../../../../actions/tools/DecisionTree/RBIActions';
import { useDispatch, useSelector } from 'react-redux';
import { hasLineItemsInOrderSelected } from '../../../../../../selectors/tools';
import { getSelectedNestedSubItems } from '../../../../../../extractFromState';
import { OrderItemsSettingsContextProvider } from '../../Common/SearchResults/Common/DTOrderSearchResult/OrderItemsWrapper/OrderItemsSettingsContext';
import RBIItems from '../../Common/SearchResults/Common/DTOrderSearchResult/OrderItemsWrapper/RBIItems/RBIItems';

const DTSelectOrderRBIPartialRefundNode = () => {
  const dispatch = useDispatch();
  const hasLineItemsSelected = useSelector(hasLineItemsInOrderSelected);
  const selectedNestedSubItems = useSelector(getSelectedNestedSubItems);
  const hasNestedSubItemsSelected =
    selectedNestedSubItems && Object.values(selectedNestedSubItems).some((list) => list.length);

  const handleNextButtonClick = async () => {
    await dispatch(processRbiOrderRefundItems());
  };

  return (
    <OrderItemsSettingsContextProvider value={{ component: RBIItems }}>
      <DTOrderSearchView
        onNextButtonClick={handleNextButtonClick}
        isNextButtonActive={hasLineItemsSelected || hasNestedSubItemsSelected}
      />
    </OrderItemsSettingsContextProvider>
  );
};

export default DTSelectOrderRBIPartialRefundNode;
